'use client';

import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';
import { redirectToLogin } from '../../redirectToLogin';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
    redirectToLogin();
  }, [error]);

  const renderError = () => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    return <NextError statusCode={0} />;
  };

  return renderError();
}

